<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Solicitudes de empaques Folio:{{folio}}
            <div>
              <template v-if="!isLoading">
                <CButton v-if="autorizada" color="info" class="mr-1 btn-header" @click="getReporte">
                  <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                  <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
                </CButton>
                <CButton v-else color="info" class="mr-1 btn-header" @click="toggleAutorizar">
                  <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                  <CIcon v-else class="mr-1" :name="`cil-check-circle`" />Autorizar
                </CButton>
              </template>
              <router-link :to="{ name: 'SolicitudEmpaque', params: { config: config } }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="12" class="text-right">
                {{ this.item.author.correo }}
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value="date"
                  disabled
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación:</label>
                <CSelect
                  :value.sync="ubicacion"
                  disabled
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="ubicaciones"
                  placeholder="Selecciona un almacén"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Cultivo:</label>

                <CInput
                  :value="cultivo"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Solicitante:</label>

                <CInput
                  :value="solicitante"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Producción:</label>

                <CInput
                  :value="nombreProduccion"
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea :value="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              :show.sync="autorizarModal"
              :no-close-on-backdrop="true"
              :centered="true"
              title="Autorizar solicitud de empaque"
              color="info"
            >
              <h5 class="text-center">¿Deseas autorizar la solicitud de empaque con folio {{ this.itemModal.name }}?</h5>
              <template #header>
                <h5 class="modal-title">Autorizar solicitud de empaque</h5>
                <CButtonClose @click="autorizarModal = false" class="text-white" />
              </template>
              <template #footer>
                <CButton @click="autorizarModal = false" color="danger">Cancelar</CButton>
                <CButton @click="autorizar(itemModal.id)" color="success">Aceptar</CButton>
              </template>
            </CModal>
            <CModal
              size="sm"
              title="Solicitud de empaque"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >{{ error }}</CModal>
            <CModal
              size="sm"
              title="Solicitud de empaque"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false"  color="success">Aceptar</CButton>
              </template>
            </CModal>
            <hr class="my-4 line" />

            <CRow>
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fieldsSecondModal"
                >
                  <template #empaque_id="{item}">
                    <td class="py-2">{{ getEmpaque(item.empaque_id) }}</td>
                  </template>
                  <template #cantidad="{item}">
                    <td class="py-2">
                      {{item.cantidad}}
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fieldsSecondModal = [
  { key: "empaque_id", label: "Empaque", _style: "width:20%" },
  { key: "cantidad", _style: "width:20%" },
];

export default {
  name: "VerEntrada",

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      item: {},
      detalles: [],
      date: null,
      ubicacion: "",
      ubicaciones: [],
      solicitante: "",
      empaque: "",
      nombreProduccion:'',
      fieldsSecondModal,
      autorizada: false,
      autorizarModal: false,
      itemModal: { id: "", name: "", index: "" },
      productos: [],
      producto: null,
      productosAll: [],
      cantidad: null,
      costo: null,
      comentarios: '',
      successModal: false,
      warningModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
      cultivo: ''
    };
  },

  created() {
    this.actualizarInfo()
  },
  computed: {
    totalDetails() {
      if (this.detalles.length) {
        return this.detalles
          .reduce(
            (acount, detail) =>
              Number(acount) +
              Number(detail.cantidad) * Number(detail.costo_unitario),
            0
          )
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0.00";
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  methods: {
    autorizar(folio){
      this.$store.dispatch("customDocumentoActualizarHTTP", {
          schema: "solicitudes_empaques",
          folio,
          payload: {
              encabezado: {
                  autorizada: true
              }
          }
      }).then(() => {
          this.alertSuccess = true
      }).catch(error => {
          this.error = error.message;
          this.warningModal = true;
          this.isLoading = false;
      }).finally(() => {
          this.autorizarModal = false;
          this.isLoading = false;
          this.actualizarInfo();
      });
    },
    toggleAutorizar() {
      this.autorizarModal = true;
      const itemIndex = {
        id: this.folio,
        name: this.folio,
        index: 0
      };
      this.itemModal = itemIndex;
    },
    getReporte(){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_solicitudes_empaques",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);


        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte salidas de empaques.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    actualizarInfo() {
    this.isLoading = true;
    this.$store;

    const serv = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "solicitudes_empaques",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      }),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ],
          wherein: [
            {
              field: "payload->pertenece_id",
              value: [this.ubicacionRaiz]
            }
          ],
          orWhere:[
            {
              field: "id",
              operator: "=",
              value: this.ubicacionRaiz
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];

    Promise.all(serv)
      .then(([item, ubicaciones]) => {
        this.item = item.data[0];
        this.ubicaciones = ubicaciones.data.map(cultivo => {
          return { value: cultivo.id, label: cultivo.payload.nombre };
        });
        this.ubicacion = this.item.payload.encabezado._relaciones?.ubicacion?.id||0;
        this.folio = this.item.payload.encabezado.folio_proveedor;
        this.productosAll = this.item.payload.detalles.map(m=>m._relaciones.empaque)
        this.detalles = this.item.payload.detalles;
        this.comentarios = this.item.payload.encabezado.comentarios;
        this.solicitante = this.item.payload.encabezado.solicitante;
        this.medias = this.item.payload.anexos;
        this.cultivo = this.item.payload.encabezado.cultivo;
        this.autorizada = !!this.item.payload.encabezado.autorizada;
        let dateDocto = new Date(this.item.payload.encabezado.fechahora);

        this.nombreProduccion = this.item.payload.encabezado.produccion;

        let year = dateDocto.getFullYear();
        let month = ("0" + (dateDocto.getMonth() + 1)).slice(-2);
        let day = ("0" + dateDocto.getDate()).slice(-2);

        this.date = `${year}-${month}-${day}`;
      })
      .finally(() => (this.isLoading = false));
  },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(()=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });

    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getEmpaque(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.nombre;
    },
  }
};
</script>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
